module.exports = __webpack_public_path__ + "img/qy_7.74377fa7.png";